export default "__VITE_ASSET__BcmFOj98__"